<ng-container *ngIf="!onlyLage else lage">
    <ng-container *ngIf="(keywords | async) as part">
        <ng-container *ngFor="let key of part">
            <div class="tour-title-wrapper">
                <span class="tour-title">{{key.name | i18n | async}}</span>
            </div>
            <div class="tour-wrapper" *ngIf="key?.childrens?.length > 0">
                <ng-container *ngFor="let op of key.childrens | slice:0:key.slicenbr">
                    <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
                        <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op['code']) >= 0 ? 'check_box' :
                            'check_box_outline_blank'}}</mat-icon>
                        <span class="tour-item-name">{{op['name'] | i18n | async}}</span>
                    </button>
                </ng-container>
                <ng-container *ngIf="key.childrens.length > 4">
                    <ng-container *ngIf="(key.slicenbr < key.childrens.length) else less">
                        <button class="showallbtn" (click)="showMore(key, key.childrens.length)" matRipple>
                            <span>{{'alle' | i18n | async}} {{key.childrens.length}} {{'anzeigen' | i18n | async}}</span>
                        </button>
                    </ng-container>
                    <ng-template #less>
                        <button class="showallbtn" (click)="showMore(key, 4)" matRipple>
                            <span>{{'weniger anzeigen' | i18n | async}}</span>
                        </button>
                    </ng-template>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #lage>
    @if(!partner?.filters?.hideLagefilter) {
    <div class="tour-title-wrapper">
        <span class="tour-title">{{keywordsLage.name}}</span>
    </div>
    <div class="tour-wrapper" *ngIf="keywordsLage?.childrens?.length > 0">
        <ng-container *ngFor="let op of keywordsLage.childrens | slice:0:keywordsLage.slicenbr">
            @if(!partner?.filters?.['hide' + op.code + 'filter']) {
            <button class="tour-item-wrapper" (click)="selected(op)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(op['code']) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <span class="tour-item-name">{{op['name'] | i18n | async}}</span>
            </button>
            }
        </ng-container>
        <ng-container *ngIf="keywordsLage.childrens.length > 4">
            <ng-container *ngIf="(keywordsLage.slicenbr < keywordsLage.childrens.length) else less">
                <button class="showallbtn" (click)="showMore(keywordsLage, keywordsLage.childrens.length)" matRipple>
                    <span>{{'alle' | i18n | async}} {{keywordsLage.childrens.length}} {{'anzeigen' | i18n | async}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(keywordsLage, 4)" matRipple>
                    <span>{{'weniger anzeigen' | i18n | async}}</span>
                </button>
            </ng-template>
        </ng-container>

    </div>
    }
</ng-template>